import React from "react";

import { withStyleProps } from "Utils/styleProps";

import { Title } from "Cobalt/Header";
import BodyText from "Common/BodyText";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const bem = makeBem("BenefitsBox");

/**
 * BenefitsBox is a component that displays the benefits of connecting your plan with SimplyInsured in a list.
 * @returns a list of benefits with a checkmark icon next to each one.
 */
let BenefitsBox = () => {
  const benefits = [
    "Deductions synced to your payroll",
    "Automatic employee enrollments and terminations",
    "Digital ID cards",
    "Access to SimplyInsured’s team of experts and support",
    "One click renewals",
    "No additional cost or fees",
    "SimplyInsured as your broker",
  ];

  return (
    <div className={bem("box")}>
      <div className={bem("header")}>
        <Title>Benefits of connecting your plan with SimplyInsured</Title>
      </div>
      {benefits.map((benefit, index) => (
        <div className={bem("row")} key={`benefits.${index}`}>
          <span className={bem("icon")}>
            <Icon icon="check-circle" size="xs" flavor="solid" />
          </span>
          <BodyText className={bem("text")} size="ns-sixteen">
            {benefit}
          </BodyText>
        </div>
      ))}
    </div>
  );
};

BenefitsBox = withStyleProps(BenefitsBox);

export { BenefitsBox };
